import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";
import { useApi } from "../../../../hooks/apiHooks/useApi";

export const useExportSeasonOfficials = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const request = useApi();
  const { seasonOfficialRoles } = useSportConfiguration();

  return useMutation<DefaultOperationSuccessResponse, Error, string[]>({
    mutationFn: (fieldNames) =>
      request(`${sport}/o/${organizationId}/seasons/${seasonId}/personRoles/export`, {
        method: "POST",
        body: {
          fieldNames,
          exportName: "season officials",
          personRoles: seasonOfficialRoles,
        },
      }),
  });
};
